import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { PayloadAction, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { FlowUnitsAPI, PreferencesModel, PressureUnitsAPI } from '@shared/models';
import { EntityReducers } from '@core/store/EntityReducers';
import { isEmpty } from 'lodash';
import { preferencesThunks } from './PreferencesThunks';

export const PREFERENCES_ENTITY_ID = 1;
export const defaultPreferencesState: PreferencesModel = {
  flowUnit: FlowUnitsAPI.CubicMeterPerHour,
  pressureUnit: PressureUnitsAPI.Bar,
};

export interface PreferencesStoreModel extends PreferencesModel {
  id: number;
}

const entityAdapter = createEntityAdapter({
  selectId: (d: PreferencesStoreModel) => d.id,
});

const slice = createSlice({
  name: EntityReducers.preferences,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
    setPreferences(state, { payload }: PayloadAction<PreferencesModel>) {
      if (!state.entities || isEmpty(state.entities)) {
        entityAdapter.upsertOne(state, { ...payload, id: PREFERENCES_ENTITY_ID });
      }

      entityAdapter.updateOne(state, {
        id: PREFERENCES_ENTITY_ID,
        changes: { ...payload },
      });
    },
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([preferencesThunks.getPreferences, preferencesThunks.savePreferences], builder);
    handleFulfilledAction(preferencesThunks.getPreferences, builder, (state, payload) => {
      entityAdapter.upsertOne(state, { ...payload, id: PREFERENCES_ENTITY_ID });
    });
    handleFulfilledAction(preferencesThunks.savePreferences, builder, (state, payload: { body: PreferencesModel }) => {
      entityAdapter.updateOne(state, {
        id: PREFERENCES_ENTITY_ID,
        changes: { ...payload.body },
      });
    });
  },
});

export const preferencesReducer = {
  slice,
  entityAdapter,
};
